module.exports = __webpack_public_path__ + "36164362dd8bb23d38c16301a22be847.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/articlelinkimage_2.jpg
// module id = 295
// module chunks = 0